import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'
import { SlideHeader } from './SlideHeader'
import { setReportType } from 'store/CustomReports/actions'
import ReportTypes from './ReportTypes'
import { setCompletedSlides } from 'store/CustomReports/actions'

export default function ReportType() {
  const { reportTypes, selectedReportType } = useSelector(
    (store) => store.customReports
  )
  const dispatch = useDispatch()

  const handleClick = (type) => {
    dispatch(setReportType(type))
  }

  useEffect(() => {
    wait(() => {
      if (selectedReportType !== null) {
        dispatch(setContinueDisabled(false, 1))
      }
    })
  }, [dispatch, selectedReportType])

  return (
    <>
      <SlideHeader header='What type of report would you like to extract?' />
      <ReportTypes
        types={reportTypes}
        selectedType={selectedReportType}
        fn={handleClick}
      />
    </>
  )
}
